import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Form, FormGroup, Radio } from 'react-bootstrap'

class NewScanModal extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handleStart = this.handleStart.bind(this)

    this.state = {}
  }

  handleShow() {
    this.setState({ show: true })
  }

  handleHide() {
    this.setState({ show: false })
  }

  handleStart() {
    this.setState({ show: false })
    this.props.startscan()
  }

  render() {
    const previousScan = this.props.previousScan

    return (
      <div>
        <Modal show={this.state.show} onHide={this.handleHide} dialogClassName="custom-modal modal-new-scan font-large" backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">Start scan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Wilt u de scan starten?</p>
            <p>Indien u eerder een scan voor deze organisatorische eenheid heeft uitgevoerd, kunt u voor uw gemak de antwoorden van deze scan importeren in de nieuwe scan. U blijft er zelf verantwoordelijk voor om de antwoorden opnieuw te beoordelen.</p>
            <p>Wilt u de antwoorden van de meest recente scan importeren?</p>

            <div className="inline-group">
              <span>Scandatum {previousScan && previousScan.startedDate}</span>
              <Form>
                <FormGroup>
                  <Radio onChange={() => this.props.onChange(true)} checked={this.props.usePreviousScan || false} inline>
                    <div className="text">Ja</div>
                  </Radio>{' '}
                  <Radio onChange={() => this.props.onChange(false)} checked={!this.props.usePreviousScan} inline>
                    <div className="text">Nee</div>
                  </Radio>{' '}
                </FormGroup>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleStart}>
              Start scan
            </Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default NewScanModal


// WEBPACK FOOTER //
// ./src/pages/NewScan/modals/index.js